module.exports = __webpack_public_path__ + "img/tuijianchapin.bf33c166.png";